import { gql } from '@apollo/client';

export const UNIT_AND_LEASE_INFO = gql`
  query GetUnitAndLeaseInfo($ticker: [String!]) {
    units(ticker: $ticker) {
      ticker
      address
      status
      monthlyRent
      photos {
        uri
      }
      onMarketLease {
        id
        monthlyRentAmount
        securityDepositAmountAmount
        status
        moveOutDate
        startDate
        endDate
        proposedLease
        firstMonthRentAmount
        isRenewal
      }
    }
  }
`;
